//更改用户状态信息
export const userStatus = (state, user) => {
  //判断用户是否存在
  if (user != null) {
    state.userInfo = JSON.parse(user);
    state.isLogin = true;
  } else if (user == null) {
    //登出时清空sessionStroage里面的参数
    sessionStorage.setItem("user", null);
    sessionStorage.setItem("userToken", "");
    state.isLogin = false;
  }
};
export const setPath = (state) => {
  state.currentPathName = localStorage.getItem("currentPathName");
};
export const setUserImage = (state, image) => {
  state.userImage = image;
};
//更改token
export const setToken = (state, token) => {
  if (token != null) {
    state.token = token;
  } else {
    state.token = "";
  }
};
// 左分机是否登录
export const leftPhoneStatus = (state, value) => {
  state.leftStatus = value;
};
// 右分机是否登录
export const rightPhoneStatus = (state, value) => {
  state.rightStatus = value;
};
export const setPhoneInfo = (state, value) => {
  state.phoneList = value;
};
export const setLeftPhoneInfo = (state, value) => {
  state.leftPhoneInfo = JSON.parse(value);
};
export const setRightPhoneInfo = (state, value) => {
  state.rightPhoneInfo = JSON.parse(value);
};
export const callingInfo = (state, value)=>{
 state.callingInfo = JSON.parse(value);
};
